"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SystemStatus = void 0;
var SystemStatus;
(function (SystemStatus) {
    SystemStatus[SystemStatus["Created"] = 0] = "Created";
    SystemStatus[SystemStatus["ConfigureSystemFailed"] = 5] = "ConfigureSystemFailed";
    SystemStatus[SystemStatus["ConfigureSystemSuccess"] = 10] = "ConfigureSystemSuccess";
    SystemStatus[SystemStatus["AutoComponentsFailed"] = 15] = "AutoComponentsFailed";
    SystemStatus[SystemStatus["AutoComponentsSuccess"] = 20] = "AutoComponentsSuccess";
    SystemStatus[SystemStatus["AutoCasesFailed"] = 22] = "AutoCasesFailed";
    SystemStatus[SystemStatus["AutoCasesSuccess"] = 23] = "AutoCasesSuccess";
    SystemStatus[SystemStatus["ValidateConfigurationFailed"] = 25] = "ValidateConfigurationFailed";
    SystemStatus[SystemStatus["ValidateConfigurationSuccess"] = 30] = "ValidateConfigurationSuccess";
    SystemStatus[SystemStatus["DesignCalculationFailed"] = 35] = "DesignCalculationFailed";
    SystemStatus[SystemStatus["DesignCalculationSuccess"] = 40] = "DesignCalculationSuccess";
    SystemStatus[SystemStatus["ValidateDesignFailed"] = 45] = "ValidateDesignFailed";
    SystemStatus[SystemStatus["ValidateDesignSuccess"] = 50] = "ValidateDesignSuccess";
    SystemStatus[SystemStatus["RatingCalculationFailed"] = 55] = "RatingCalculationFailed";
    SystemStatus[SystemStatus["RatingCalculationSuccess"] = 60] = "RatingCalculationSuccess";
    SystemStatus[SystemStatus["GenerateCasingsFailed"] = 65] = "GenerateCasingsFailed";
    SystemStatus[SystemStatus["GenerateCasingsSuccess"] = 70] = "GenerateCasingsSuccess";
    SystemStatus[SystemStatus["ValidateFinalFailed"] = 71] = "ValidateFinalFailed";
    SystemStatus[SystemStatus["ValidateFinalSuccess"] = 72] = "ValidateFinalSuccess";
    SystemStatus[SystemStatus["SoundFailed"] = 73] = "SoundFailed";
    SystemStatus[SystemStatus["SoundSuccess"] = 74] = "SoundSuccess";
    SystemStatus[SystemStatus["PostProcessingFailed"] = 77] = "PostProcessingFailed";
    SystemStatus[SystemStatus["PostProcessingSuccess"] = 78] = "PostProcessingSuccess";
    SystemStatus[SystemStatus["PriceCalculationFailed"] = 79] = "PriceCalculationFailed";
    SystemStatus[SystemStatus["PriceCalculationSuccess"] = 80] = "PriceCalculationSuccess";
    SystemStatus[SystemStatus["EnergyCalculationPending"] = 81] = "EnergyCalculationPending";
    SystemStatus[SystemStatus["EnergyCalculationFailed"] = 82] = "EnergyCalculationFailed";
    SystemStatus[SystemStatus["EnergyCalculationSuccess"] = 83] = "EnergyCalculationSuccess";
    SystemStatus[SystemStatus["ValidateMCompareFailed"] = 84] = "ValidateMCompareFailed";
    SystemStatus[SystemStatus["ValidateMCompareSuccess"] = 85] = "ValidateMCompareSuccess";
    SystemStatus[SystemStatus["MCompareCalculationFailed"] = 86] = "MCompareCalculationFailed";
    SystemStatus[SystemStatus["MCompareCalculationSuccess"] = 87] = "MCompareCalculationSuccess";
    SystemStatus[SystemStatus["LockFailed"] = 89] = "LockFailed";
    SystemStatus[SystemStatus["LockSuccess"] = 90] = "LockSuccess";
    SystemStatus[SystemStatus["OrderFailed"] = 95] = "OrderFailed";
    SystemStatus[SystemStatus["OrderSuccess"] = 100] = "OrderSuccess";
})(SystemStatus || (exports.SystemStatus = SystemStatus = {}));
//# sourceMappingURL=system-status.js.map